import styled from 'styled-components';
import { extractNumber } from '../../../functions/utils/extractNumber';
import { LauncherElementData, useLauncherElementsStore } from '../../../hooks/stores/launcherElementsStore';

export const PaddingArea = ({ elementID }: { elementID: string | null }) => {
  const [launcherElementsData] = useLauncherElementsStore<Record<string, LauncherElementData>>();
  const element = launcherElementsData[elementID || ''];

  const paddingTop = extractNumber(element?.props?.class?.paddingTop);
  const paddingBottom = extractNumber(element?.props?.class?.paddingBottom);
  const paddingLeft = extractNumber(element?.props?.class?.paddingLeft);
  const paddingRight = extractNumber(element?.props?.class?.paddingRight);

  return (
    elementID && (
      <Container
        style={{
          top: paddingTop || 0,
          left: paddingLeft || 0,
          right: paddingRight || 0,
          bottom: paddingBottom || 0,
          borderTop: paddingTop ? '1px dotted #08941f' : undefined,
          borderLeft: paddingLeft ? '1px dotted #08941f' : undefined,
          borderRight: paddingRight ? '1px dotted #08941f' : undefined,
          borderBottom: paddingBottom ? '1px dotted #08941f' : undefined,
        }}
      />
    )
  );
};

const Container = styled.div`
  pointer-events: none;
  box-sizing: border-box;
  position: absolute;

  display: flex;
  justify-content: center;
  align-items: center;
`;
